import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  CardContent,
  Typography,
  IconButton,
  Grid,
  Tabs,
  Tab,
  Avatar,
  CircularProgress,
  Snackbar,
  Alert
} from "@mui/material";
import { CloudUpload, Download, MoreVert, Upload } from "@mui/icons-material";
import { Container } from "shards-react";
import axios from "axios";

const Profile = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const tabRefs = useRef([]);

  // Ref for each tab
  const handleTabRef = index => el => {
    tabRefs.current[index] = el;
  };

  const [indicatorWidth, setIndicatorWidth] = useState(0);
  const [profileDetails, setUserProfileDetails] = useState([]);
  const [profileInfo, setUserProfileInfoFertilizer] = useState([]);
  const [reference, setUserProfileInfoReference] = useState([]);
  
  const [token, setToken] = useState("");
  const [uploadCv, setUploadCv] = useState();
  const [uploadFertilizerDataset, setUploadFertilizerDataset] = useState();
  const [uploadReferenceDataset, setUploadReferenceDataset] = useState();
  const [loading, setLoading] = useState({
    api1: false,
    api2: false,
    api3: false
  });
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    if (tabRefs.current[tabIndex]) {
      setIndicatorWidth(tabRefs.current[tabIndex].offsetWidth); // Set indicator width based on selected tab
    }
  }, [tabIndex]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/api/v1/get/user`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}` // Replace with your token source
            }
          }
        );
        if (response.status == 200) {
          setUserProfileDetails(response.data.data);

          // Parse the str ing into an array
          const urlsfertilizer = JSON.parse(
            response.data.data[0].fertilizer_dataset
          );
          
          // Process each URL 
          let fileInfo = []
          if (urlsfertilizer )
           fileInfo = urlsfertilizer.map(url => {
            const path = new URL(url).pathname; // Extract path from URL
            const filename = decodeURIComponent(path.split("/").pop()); // Decode URL encoding (e.g., %20 → space)
            const lastDotIndex = filename.lastIndexOf("."); // Find last dot position

            const name =
              lastDotIndex !== -1
                ? filename.substring(0, lastDotIndex)
                : filename; // Extract name
            const ext =
              lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : ""; // Extract extension

            return {
              file_name: name,
              format: ext
            };
          });
          // Parse the string into an array
          const urlsReference = JSON.parse(
            response.data.data[0].reference_dataset
          );
          let fileInfoReference = []

          // Process each URL
          if (urlsReference)
           fileInfoReference = urlsReference.map(url => {
            const path = new URL(url).pathname; // Extract path from URL
            const filename = decodeURIComponent(path.split("/").pop()); // Decode URL encoding (e.g., %20 → space)
            const lastDotIndex = filename.lastIndexOf("."); // Find last dot position

            const name =
              lastDotIndex !== -1
                ? filename.substring(0, lastDotIndex)
                : filename; // Extract name
            const ext =
              lastDotIndex !== -1 ? filename.substring(lastDotIndex + 1) : ""; // Extract extension

            return {
              file_name: name,
              format: ext
            };
          });


          setUserProfileInfoFertilizer(fileInfo);
          setUserProfileInfoReference(fileInfoReference);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();

    // Optional: Polling every 10 seconds
    // const interval = setInterval(fetchData, 10000);

    // return () => clearInterval(interval); // Cleanup interval on unmount
  }, [refresh]);



  // const handleFileUpload = event => {
  //   const files = Array.from(event.target.files);
  //   setUploadedFiles(prevFiles => [...prevFiles, ...files]);
  // };

  const handleFileUploadReference = async event => {
    if (!event.target.files) return; // Ensure files exist

    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    setUploadReferenceDataset(prevFiles => [
      ...new Set([...(prevFiles || []), ...files])
    ]); // Prevent duplicates

    const formData = new FormData();
    files.forEach(file => formData.append("reference_dataset", file)); // Ensure backend supports multiple files

    setLoading(prev => ({ ...prev, api2: true }));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/upload/data`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}` // No need for Content-Type
          }
        }
      );

      if (response.status === 201) {
        setMessage("Dataset added successfully");
        setSeverity("success");
        setRefresh((prev)=> !prev)
        setOpen(true);
      }
    } catch (error) {
      setMessage("Some problem occurred, please try again");
      setSeverity("error");
      setOpen(true);
      console.error("Upload Error:", error);
    } finally {
      setLoading(prev => ({ ...prev, api2: false }));
    }
  };

  const handleFileUploadCV = async event => {
    const file = event.target.files[0]; // Ensure only a single file is processed
    if (!file) return;
    const formData = new FormData();
    formData.append("cv", file);
    setLoading(prev => ({ ...prev, api3: true }));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/upload/data`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`
          }
        }
      );

      if (response.status === 201) {
        setMessage("Resume added successfully");
        setSeverity("success");
        setOpen(true);
      }

      console.log("Upload Success:", response.data);
    } catch (error) {
      setMessage("Some problem occurred, please try again");
      setSeverity("error");
      setOpen(true);
      console.error("Upload Error:", error);
    } finally {
      setLoading(prev => ({ ...prev, api3: false }));
    }
  };

  const handleFileUploadFertilizer = async event => {
    if (!event.target.files) return; // Ensure files exist

    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    setUploadFertilizerDataset(prevFiles => [
      ...new Set([...(prevFiles || []), ...files])
    ]); // Prevent duplicates

    const formData = new FormData();
    files.forEach(file => formData.append("fertilizer_dataset", file)); // Ensure backend supports multiple files

    setLoading(prev => ({ ...prev, api1: true }));

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/upload/data`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}` // No need for Content-Type
          }
        }
      );

      if (response.status === 201) {
        setRefresh((prev)=> !prev)
        setMessage("Dataset added successfully");
        setSeverity("success");
        setOpen(true);
      }
    } catch (error) {
      setMessage("Some problem occurred, please try again");
      setSeverity("error");
      setOpen(true);
      console.error("Upload Error:", error);
    } finally {
      setLoading(prev => ({ ...prev, api1: false }));
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/generate-sas-token?container=expert-profile`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`, // Replace with your token source
              "Content-Type": "application/json"
            }
          }
        );

        if (response.data.status === "success") {
          setToken(response.data.sas_token);
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchData();
  }, [refresh]);

  return (
    <Container
      fluid
      className="main-content-container px-4 py-4"
      style={{ backgroundColor: "white" }}
    >
      <div style={{ padding: 24, margin: "auto" }}>
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{
            marginBottom: "3.94rem",
            color: "rgba(0, 0, 0, 0.80)",
            textAlign: "center",
            fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
            fontFamily: "Inter",
            fontSize: "1.5rem",
            fontStyle: "normal",
            fontWeight: 600,
            lineHeight: "1.125rem"
          }}
        >
          Profile
        </Typography>

        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
            <Avatar
              alt="Profile"
              sx={{
                width: "5rem",
                height: "5rem",
                flexShrink: 0,
                borderRadius: "5rem",
                background: `https://via.placeholder.com/80 lightgray 50% / cover no-repeat, #D9D9D9`
              }}
            />

            <div>
              <Typography
                variant="h6"
                sx={{
                  color: "#000",
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter",
                  fontSize: "1.25rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "1.125rem" // 90%
                }}
              >
                {profileDetails.length ? profileDetails[0].name : ""}
              </Typography>
              
              <a
                href={
                  profileDetails.length
                    ? `${profileDetails[0].uploaded_cv}?${token}`
                    : "#"
                }
                target="_blank"
                style={{
                  paddingTop: "0.88rem",
                  color: "#006BE0",
                  fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                  fontFamily: "Inter",
                  fontSize: "0.875rem",
                  fontStyle: "normal",
                  fontWeight: 500,
                  lineHeight: "1.125rem", // 128.571%
                  textDecorationLine: "underline",
                  textDecorationStyle: "solid",
                  textDecorationSkipInk: "none",
                  textDecorationThickness: "auto",
                  textUnderlineOffset: "auto",
                  textUnderlinePosition: "from-font"
                }}
              >
                Download CV
              </a>
            </div>
          </div>
          <label htmlFor="upload-cv">
            <input
              type="file"
              id="upload-cv"
              style={{ display: "none" }}
              onChange={handleFileUploadCV}
            />
            <Button
              component="span"
              variant="contained"
              startIcon={<CloudUpload />}
              sx={{
                display: "flex",
                padding: "1rem 1.5rem",
                justifyContent: "center",
                alignItems: "center",
                gap: "0.25rem",
                borderRadius: "0.5rem",
                background: "#2A2A2A",
                whiteSpace: "nowrap", // fixed from "none" to "nowrap"
                color: "#FFF",
                fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                fontFamily: "Inter",
                fontSize: "0.875rem",
                fontStyle: "normal",
                fontWeight: 600,
                lineHeight: "1.125rem",
                cursor: "pointer"
              }}
            >
              {!loading["api3"] ? (
                "Upload CV"
              ) : (
                <CircularProgress sx={{ color: "#fff" }} size={26} />
              )}
            </Button>
          </label>
        </div>
        <Tabs
          value={tabIndex}
          onChange={(e, newValue) => setTabIndex(newValue)}
          style={{ marginTop: "3.75rem" }}
          sx={{
            color: "#000",
            fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
            fontFamily: "Inter, sans-serif",
            fontSize: "1.125rem",
            fontStyle: "normal",
            fontWeight: 500,
            lineHeight: "1.125rem",
            "& .MuiTabs-indicator": {
              backgroundColor: "#000", // Line color under the selected tab
              height: "2px", // Adjust the height of the indicator
              width: `${indicatorWidth}px`, // Adjust width based on selected tab
              transition: "width 0.3s ease", // Smooth transition for width change
              top: "calc(100% - 13px)"
            }
          }}
        >
          <Tab
            label="Fertilizer Dataset"
            ref={handleTabRef(0)}
            sx={{
              color: "#000",
              fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
              fontFamily: "Inter, sans-serif",
              fontSize: "1.125rem",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "1.125rem",
              textTransform: "none", // Prevent text from being capitalized
              paddingBottom: "0px", // Decrease the bottom padding to reduce gap
              minHeight: "auto", // Adjust the min height to prevent unnecessary space
              "&.Mui-selected": {
                color: "black" // Selected tab color
              }
            }}
          />
          <Tab
            label="Reference Dataset"
            ref={handleTabRef(1)}
            sx={{
              color: "#000",
              fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
              fontFamily: "Inter, sans-serif",
              fontSize: "1.125rem",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "1.125rem",
              textTransform: "none", // Prevent text from being capitalized
              paddingBottom: "0px", // Decrease the bottom padding to reduce gap
              minHeight: "auto", // Adjust the min height to prevent unnecessary space
              "&.Mui-selected": {
                color: "black" // Selected tab color
              }
            }}
          />
        </Tabs>

        {tabIndex === 0 && (
          <>
            <div
              style={{
                marginTop: "1.19rem",
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <label htmlFor="upload-fertilizer">
                <input
                  type="file"
                  multiple
                  id="upload-fertilizer"
                  style={{ display: "none" }}
                  onChange={handleFileUploadFertilizer}
                />
                <Button
                  component="span"
                  variant="contained"
                  color="primary"
                  startIcon={<Upload />}
                  sx={{
                    display: "inline-flex",
                    padding: "1rem 1.25rem",
                    justifyContent: "center",
                    alignItems: "center",
                    gap: "0.25rem",
                    borderRadius: "0.5rem",
                    backgroundColor: "#006BE0",
                    color: "#FFF",
                    fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                    fontFamily: "Inter",
                    fontSize: "0.875rem",
                    fontStyle: "normal",
                    fontWeight: 600,
                    textTransform: "none",
                    lineHeight: "1.125rem" // 128.571%
                  }}
                >
                  {!loading["api1"] ? (
                    "Fertilizer dataset"
                  ) : (
                    <CircularProgress sx={{ color: "#fff" }} size={26} />
                  )}
                </Button>
              </label>
            </div>
            <Grid container spacing={2} style={{ marginTop: 16 }}>
              {profileInfo && profileInfo.length > 0 ? (
                profileInfo.map((file, index) => (
                  <Grid item xs={6} sm={4} md={3} lg={3} key={index}>
                    <div
                      style={{
                        paddingLeft: "1.25rem",
                        paddingRight: "1.25rem",
                        height: "4.375rem",
                        flexShrink: 0,
                        borderRadius: "0.5rem",
                        background: "#F1F3F8"
                      }}
                    >
                      <Grid container>
                        <Grid item xs={9} style={{ paddingTop: "1rem" }}>
                          <Typography
                            variant="body1"
                            fontWeight="bold"
                            sx={{
                              color: "#000",
                              fontFeatureSettings:
                                "'ss01' on, 'cv01' on, 'cv11' on",
                              fontFamily: "Inter",
                              fontSize: "0.875rem",
                              fontStyle: "normal",
                              fontWeight: 500,
                              lineHeight: "1.125rem"
                            }}
                          >
                            {file.file_name}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          style={{
                            display: "flex",
                            paddingTop: "1rem",
                            justifyContent: "flex-end"
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_825_312)">
                              <path
                                d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
                                fill="#5C5C5C"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_825_312">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{
                              color: "#5E5E5E",
                              fontFamily: "Inter",
                              fontSize: "0.75rem",
                              fontStyle: "normal",
                              fontWeight: 400,
                              lineHeight: "1.125rem" /* 150% */
                            }}
                          >
                            {file.format}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                ))
              ) : profileInfo === null || profileInfo === undefined ? (
                <CircularProgress sx={{ color: "black" }} size={26} />
              ) : (
                <Typography
                  variant="h6"
                  align="center"
                  style={{ marginTop: 24 }}
                >
                  No Fertilizer Dataset Available
                </Typography>
              )}
            </Grid>
          </>
        )}
        {tabIndex === 1 && (
          <>
            <div
              style={{
                marginTop: "1.19rem",
                display: "flex",
                justifyContent: "flex-end"
              }}
            >
              <label htmlFor="upload-Reference">
                <input
                  type="file"
                  multiple
                  id="upload-Reference"
                  style={{ display: "none" }}
                  onChange={handleFileUploadReference}
                />
                <Button
                  component="span"
                  variant="contained"
                  color="primary"
                  startIcon={<Upload />}
                  sx={{
                    display: "inline-flex",
                    padding: "1rem 1.25rem",
                    justifyContent: "center",
                    alignItems: "center",
                    textTransform: "none",
                    gap: "0.25rem",
                    borderRadius: "0.5rem",
                    backgroundColor: "#006BE0",
                    color: "#FFF",
                    fontFeatureSettings: "'ss01' on, 'cv01' on, 'cv11' on",
                    fontFamily: "Inter",
                    fontSize: "0.875rem",
                    fontStyle: "normal",
                    fontWeight: 600,
                    lineHeight: "1.125rem" // 128.571%
                  }}
                >
                  {!loading["api2"] ? (
                    "Reference Dataset"
                  ) : (
                    <CircularProgress sx={{ color: "#fff" }} size={26} />
                  )}
                </Button>
              </label>
            </div>
            <Grid container spacing={2} style={{ marginTop: 16 }}>
              {reference && reference.length > 0 ? (
                reference.map((file, index) => (
                  <Grid item xs={6} sm={4} md={3} lg={3} key={index}>
                    <div
                      style={{
                        paddingLeft: "1.25rem",
                        paddingRight: "1.25rem",
                        height: "4.375rem",
                        flexShrink: 0,
                        borderRadius: "0.5rem",
                        background: "#F1F3F8"
                      }}
                    >
                      <Grid container>
                        <Grid item xs={9} style={{ paddingTop: "1rem" }}>
                          <Typography
                            variant="body1"
                            fontWeight="bold"
                            sx={{
                              color: "#000",
                              fontFeatureSettings:
                                "'ss01' on, 'cv01' on, 'cv11' on",
                              fontFamily: "Inter",
                              fontSize: "0.875rem",
                              fontStyle: "normal",
                              fontWeight: 500,
                              lineHeight: "1.125rem"
                            }}
                          >
                            {file.file_name}
                          </Typography>
                        </Grid>
                        <Grid
                          item
                          xs={3}
                          style={{
                            display: "flex",
                            paddingTop: "1rem",
                            justifyContent: "flex-end"
                          }}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                          >
                            <g clipPath="url(#clip0_825_312)">
                              <path
                                d="M12 8C13.1 8 14 7.1 14 6C14 4.9 13.1 4 12 4C10.9 4 10 4.9 10 6C10 7.1 10.9 8 12 8ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM12 16C10.9 16 10 16.9 10 18C10 19.1 10.9 20 12 20C13.1 20 14 19.1 14 18C14 16.9 13.1 16 12 16Z"
                                fill="#5C5C5C"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_825_312">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            variant="body2"
                            color="textSecondary"
                            sx={{
                              color: "#5E5E5E",
                              fontFamily: "Inter",
                              fontSize: "0.75rem",
                              fontStyle: "normal",
                              fontWeight: 400,
                              lineHeight: "1.125rem" /* 150% */
                            }}
                          >
                            {file.format}
                          </Typography>
                        </Grid>
                      </Grid>
                    </div>
                  </Grid>
                ))
              ) : reference === null || reference === undefined ? (
                <CircularProgress sx={{ color: "black" }} size={26} />
              ) : (
                <Typography
                  variant="h6"
                  align="center"
                  style={{ marginTop: 24 }}
                >
                  No Reference Dataset Available
                </Typography>
              )}
            </Grid>
          </>
        )}
      </div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>
    </Container>
  );
};

export default Profile;
